module.exports = __webpack_public_path__ + "img/alarms-now.f830ebce.png";